(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["footer-copyright"] && !Shopify.designMode) return;
  try {
    if (!window.__whoHouseCookiePreferencesBound) {
    window.__whoHouseCookiePreferencesBound = true;

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest('[data-cookie-preferences]');
      if (!trigger) return;

      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        window.privacyBanner.showPreferences();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
